import React, { useState, useRef, useMemo, useEffect } from 'react';
import * as PropTypes from 'prop-types';
import ModalDrawer from '../ModalDrawer';
import Button, { ButtonSizes, ButtonStyles } from '../../Button/Button';
import BetaIcon, { IconColors, IconSizes } from '../../Icons/Icon';
import { TRANSLATIONS } from '../../../../translations';
import { ModalOrderCard } from './ModalOrderCard';
import Dialog, { DialogAlignments, DialogTypes } from '../../Dialog/Dialog';
import { BREAKPOINTS } from '../../../../constants';
import { useMatchesMinWidth } from '../../../hooks/useMatchesMinWidth';
import { Loader } from '../../common';

const CompleteRefundOnHold = ({
  goBack,
  isOpen,
  setIsOpen,
  modalTitle,
  order,
  onSubmit,
  isLoading,
}) => {
  const isDeviceSmallerThanMblLandscape = !useMatchesMinWidth(
    BREAKPOINTS.MBL_LANDSCAPE
  );

  return (
    <ModalDrawer
      goBack={() => goBack()}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      isDeviceSmallerThanTablet={isDeviceSmallerThanMblLandscape}
      modalCustomWidth={640}
      title={modalTitle}
      content={
        <div className="pl-m pr-m pt-xl pb-xl w-100% d-flex flex-column gap-m">
          {isLoading ? (
            <div className="d-flex justify-center text-center">
              <Loader loading={isLoading} />
            </div>
          ) : (
            <>
              <Dialog
                align={DialogAlignments.row}
                type={DialogTypes.feature}
                content={
                  TRANSLATIONS.BY_PROCEEDING_WITH_THE_CANCELLATION_THE_AMOUNT_WILL_NOT_BE_CHARGED
                }
                icon={
                  <BetaIcon
                    name={'info'}
                    color={IconColors.regular}
                    size={IconSizes[24]}
                  />
                }
              />
              <div className="d-flex flex-column gap-xs">
                <div
                  className="typography__p3 typography__neutral text-left"
                  dangerouslySetInnerHTML={{
                    __html:
                      TRANSLATIONS.CANCELLATION_REQUEST_SUMMARY_YOU_CONFIRM_THE_FOLLOWING_CANCELLATION,
                  }}
                />
                <ModalOrderCard order={order} toBeRefunded={true} />
              </div>
            </>
          )}
        </div>
      }
      footer={
        isLoading ? null : (
          <div className="d-flex gap-m pb-m pl-xl pr-xl">
            <Button
              disabled={isLoading}
              classNames={'flex-1 pr-m pl-m'}
              size={ButtonSizes.s}
              style={ButtonStyles.empty}
              label={TRANSLATIONS.CANCEL}
              onClick={() => setIsOpen(false)}
            />
            <Button
              disabled={isLoading}
              classNames={'flex-1 pr-m pl-m'}
              size={ButtonSizes.s}
              style={ButtonStyles.secondary}
              label={TRANSLATIONS.CONFIRM}
              onClick={() => onSubmit()}
            />
          </div>
        )
      }
    />
  );
};

CompleteRefundOnHold.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  order: PropTypes.object.isRequired,
};

export { CompleteRefundOnHold };
